import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import GameModeSelection from './components/GameModeSelection';
import ChessGame from './components/ChessGame';
import Leaderboard from './components/Leaderboard';
import PlayerStats from './components/PlayerStats';
import InteractiveTutorial from './components/InteractiveTutorial';
import AdminLogin from './components/AdminLogin';
import AdminPanel from './components/AdminPanel';
import AdminRoute from './components/AdminRoute';
import { initializeAdminSystem } from './utils/adminManager';
import { initializeUserSystem } from './utils/userManager';
import './App.css';

function App() {
  useEffect(() => {
    // Initialize systems on app start
    initializeAdminSystem();
    initializeUserSystem();
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
        <Routes>
          <Route path="/" element={<GameModeSelection />} />
          <Route path="/game/:mode" element={<ChessGame />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/stats" element={<PlayerStats />} />
          <Route path="/tutorial" element={<InteractiveTutorial />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin" 
            element={
              <AdminRoute>
                <AdminPanel />
              </AdminRoute>
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;